import store from '@/store'

export const authCallbacks = Object.freeze({
  isAuthorized (result) {
    if (!result) {
      return
    }

    store.commit('auth/authSuccess', 'temporary')
    store.dispatch('auth/authenticate')
      .catch(() => {
        //
      })
  },
  authSuccessCallback (ticket) {
    return store.dispatch('auth/authSuccess', ticket)
  },
  authFailureCallback () {
    return store.dispatch('auth/authFailure')
  }
})
